import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  footer_container: {
    width: "100%",
  },
  footer: {
    // position: "fixed",
    // bottom: 0,
    // // left: "50%",
    // // background: "#fbfbfb",
    // width: "Calc(100% - 15rem)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
  },
  footer_text: {
    fontFamily: "inter !important",
    color: "#667085",
    fontSize: "14px !important",
    "& span": {
      color: "#25D5A1",
    },
  },
}));
